import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy-src/utility/telemetry';

export const sharedQuizActionEvent = ({ subjectId, quizId, action }) => {
  const data = {
    app: 'ui-fym',
    event_type: 'shared_quiz_action',
    action,
    quiz_id: quizId,
    subject_id: subjectId,
    referrer:
      window.sessionStorage.getItem('EXTERNAL_REFERRER_URL') ||
      document.referrer,
  };
  sendToTelemetry(Object.assign(data, TLTRY_DEFAULTS[0]));
};
